import { SingleSignOnTypes } from '@/types/registration.types';
import { ICONS } from '@ui/icons/types';

export interface SignInOption {
  type: SingleSignOnTypes;
  label: string;
  icon: string;
  uuid?: string;
  value?: string;
}

export const SignInOptionsList: SignInOption[] = [
  { type: SingleSignOnTypes.Google, label: 'Google', icon: ICONS.GOOGLE_G_OUTLINE },
];
